//#region src/core/i18n/locales/cy.ts
var cy_default = {
	buttons: {
		play: "Chwarae",
		pause: "Oedi",
		replay: "Ailchwarae",
		mute: "Pylu",
		unmute: "Dad-bylu"
	},
	seek: {
		forward: "Neidla ymlaen {seconds} eiliad",
		backward: "Neidla yn ôl {seconds} eiliad"
	},
	fullscreen: {
		enter: "Sgrîn Lawn",
		exit: "Gadael sgrîn lawn"
	},
	captions: {
		enable: "Galluogi capsiynau",
		disable: "Analluogi capsiynau"
	},
	pip: {
		enter: "Llun mewn llun",
		exit: "Gadael llun mewn llun"
	},
	live: {
		playing: "Yn chwarae’n fyw",
		seekToEdge: "Mynd i’r ymyl byw",
		badge: "Yn fyw"
	},
	cast: {
		start: "Dechrau bwrw",
		stop: "Stopio bwrw",
		connecting: "Cysylltu"
	},
	airplay: {
		start: "Cychwyn AirPlay",
		stop: "Stopio AirPlay"
	},
	slider: { seek: "Chwilio" },
	time: {
		current: "Amser Cyfredol",
		duration: "Parhad",
		remaining: "Amser ar ôl",
		elapsedSuffix: "{duration} o'r amser a aeth heibio",
		durationSuffix: "{duration} o hyd",
		remainingSuffix: "{duration} yn weddill",
		showElapsed: "Dangos yr amser a aeth heibio, {duration}.",
		showDuration: "Dangos hyd, {duration}.",
		showRemaining: "Dangos yr amser sy'n weddill, {duration}.",
		toggleElapsed: "Toglo rhwng yr amser a aeth heibio a'r amser sy'n weddill.",
		toggleDuration: "Toglo rhwng yr hyd a'r amser sy'n weddill.",
		position: "{current} o {duration}",
		unknown: "Nid yw'r cyfrwng wedi llwytho, amser anhysbys."
	},
	playback: { rate: "Cyfradd Chwarae {rate}" },
	volume: {
		mutedValue: "{percent}, mud",
		muted: "Mud",
		label: "Sain",
		value: "Sain {value}"
	},
	status: {
		captionsOn: "Capsiynau ymlaen",
		captionsOff: "Capsiynau i ffwrdd",
		paused: "Wedi oedi",
		playing: "Yn chwarae",
		fullscreen: "Sgrîn lawn",
		pip: "Llun mewn llun",
		exitPip: "Gadael llun mewn llun",
		seekedTo: "Wedi symud i {time}"
	},
	container: { label: "Chwaraewr cyfryngau" },
	errors: {
		aborted: "Atalwyd y fideo gennych",
		network: "Mae gwall rhwydwaith wedi achosi methiant lawrlwytho.",
		decode: "Atalwyd y fideo oherwydd problem llygredd data neu oherwydd nid yw'ch porwr yn cefnogi nodweddion penodol o'r fideo.",
		source: "Ni lwythodd y fideo, oherwydd methiant gweinydd neu rwydwaith, neu achos nid yw'r system yn cefnogi'r fformat.",
		encrypted: "Mae'r fideo wedi ei amgryptio ac nid oes allweddion gennym.",
		unplayable: "Nid yw'r chwaraewr yn cefnogi'r cyfrwng hwn.",
		title: "Aeth rhywbeth o'i le.",
		unexpected: "Digwyddodd gwall. Ceisiwch eto."
	},
	common: {
		empty: "",
		ok: "Cau"
	},
	menu: {
		settings: "Gosodiadau",
		quality: "Ansawdd",
		audio: "Sain",
		default: "Rhagosodedig",
		speed: "Cyflymder",
		captions: "Capsiynau",
		playbackRate: "Cyfradd chwarae",
		back: "Yn ôl",
		off: "I ffwrdd",
		auto: "Awtomatig",
		autoWithLabel: "Awtomatig ({label})",
		subtitles: "Isdeitlau"
	}
};
//#endregion
export { cy_default as default };

//# sourceMappingURL=cy.js.map